import { ContextUrl } from '../../common/utils/ContextUrl';
import { SiteHelper } from '../../common/utils/SiteHelper';
import AdaApi from '../../common/api/adaAPI';
import Preloader from '../Preloader';

const ValidateUser = (element) => {
    const isMemberArea = element.querySelector('.js-member-area');
    const isIntranetSite = SiteHelper.isIntranetSite();

    if (!isMemberArea || isIntranetSite) {
        return;
    }

    const api = new AdaApi();

    const loader = new Preloader();
    loader.show();

    const hideLoader = () => {
        loader.hide();
    };

    api.validate()
        .then(response => {
            hideLoader();
        })
        .catch(error => {
            //TODO: Need to handle 401 and 500. Is it better to show a modal with a message? sending to the login page will require passing some data to show appropriate message

            //cookie is not valid. So, remove it.
            window.hubCookie.unset();

            //redirect the user to the login page with the current URL as the context URL
            const qs = ContextUrl.set(window.location.search);
            window.location = `${window.hubConfig.loginUrl}?${qs}`;
        });
};

export { ValidateUser };


// WEBPACK FOOTER //
// ./src/nams2020/webparts/Validate/index.js